module.exports = __webpack_public_path__ + "img/2c02ca8.png";